// ===========================================
// HELPER: mensaje al cliente por forma de pago (Monotributo)
// ===========================================
// Función pura que arma el cuerpo del mensaje según la forma de pago elegida.
// El caller (EnviarPresentadoEmailDialog) le agrega el cierre "Saludos / firma".

export type FormaPago = 'VEP' | 'debito_automatico' | 'efectivo'

interface DatosMensajeMonotributo {
  monto: string
  fechaVencimiento: string
}

// ORR-185: el saludo lo pone el template (EmailLayout: "Hola {nombre},"). Antes
// este mensaje agregaba "Buen día, {nombre}!", duplicando el saludo en el mail.
export function generarMensajeMonotributo(
  forma: FormaPago,
  { monto, fechaVencimiento }: DatosMensajeMonotributo,
): string {
  if (forma === 'VEP') {
    return `Ya se encuentra generado el VEP de tu cuota mensual de monotributo por ${monto}. Podés encontrarla en tu homebanking!
La misma vence el día ${fechaVencimiento}`
  }

  if (forma === 'debito_automatico') {
    return `Recordá tener el saldo disponible el día ${fechaVencimiento} para que se realice el débito automático de tu cuota mensual de monotributo por ${monto}.`
  }

  return `Recordá que tu cuota mensual de monotributo por ${monto} vence el día ${fechaVencimiento}. Podés abonarlo en efectivo con tu credencial de pago!`
}
